export const PATIENT_DETAIL_CASE = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'created',
    label: 'Created',
  },
  {
    value: 'treated',
    label: 'Treated',
  },
  {
    value: 'date_of_next_treatment',
    label: 'Next Treatment',
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: 'not_treated_reason',
    label: 'Not Treated Reason',
  },
  {
    value: 'indication',
    label: 'Indication',
  },
  {
    value: '',
    label: 'FAM/Office Note',
  },
];
export const GLOBAL_PATIENT_DETAIL_CASE = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'created',
    label: 'Created',
  },
  {
    value: 'treated',
    label: 'Treated',
  },
  {
    value: 'date_of_next_treatment',
    label: 'Next Treatment',
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: 'not_treated_reason',
    label: 'Not Treated Reason',
  },
  {
    value: 'indication',
    label: 'Indication',
  },
  {
    value: '',
    label: 'FAM/Office Note',
  },
];